module.exports = __webpack_public_path__ + "img/Birte-Schmidt-v2-560.5d695f19.jpg";